import styled from 'styled-components'

export const Image = styled.img`
  width: 100%;
  object-fit: contain;
`
